import React from "react";
import SecondaryButton from "../buttons/SecondaryButton";
import PrimaryButton from "../buttons/PrimaryButton";
import Modal1 from "./Modal1";

const ConfirmationModal = ({ onDismiss, onClose, isOpen }) => {
  return (
    <Modal1 onClose={onClose} isOpen={isOpen}>
      <div className="bg-white flex flex-col  w-c400 rounded-3xl ">
        <div className="flex flex-col  w-full">
          <div className="border-b-1 p-4 text-h3">Fenêtre de confirmation</div>
          <div className="bg-neutral-50 p-4 flex flex-col">
            <div className="flex flex-row justify-between">
              <div className="text-h3 text-shadow_50">
                Etes vous sûr de vouloir réaliser cette action ?
              </div>
            </div>
          </div>
          <div className="flex flex-row gap-2 justify-between border-t-1 p-4">
            {" "}
            <PrimaryButton
              className="min-w-fit"
              sx={{ backgroundColor: "red" }}
              onClick={() => onDismiss(true)}
            >
              Confirmer
            </PrimaryButton>
            <SecondaryButton
              className="flex-grow items-center justify-center"
              onClick={() => onDismiss(false)}
            >
              Revenir en arrière
            </SecondaryButton>
          </div>
        </div>
      </div>
    </Modal1>
  );
};

export default ConfirmationModal;
